'use client'

import { Toaster } from '@/components/ui/toaster'
import { Toaster as Sonner } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'

// Dynamically import components with no SSR
const Index = dynamic(() => import('../pages/Index'), { ssr: false })
const NotFound = dynamic(() => import('../pages/NotFound'), { ssr: false })
const PrivacyPolicy = dynamic(() => import('../pages/PrivacyPolicy'), {
  ssr: false,
})
const TermsOfService = dynamic(() => import('../pages/TermsOfService'), {
  ssr: false,
})
const Contact = dynamic(() => import('../pages/Contact'), { ssr: false })
const DeleteAccount = dynamic(() => import('../pages/DeleteAccount'), {
  ssr: false,
})

import { ThemeProvider } from '@/components/theme-provider'

const queryClient = new QueryClient()

const App = () => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ThemeProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <Routes>
              <Route path='/' element={<Index />} />
              <Route path='/privacy-policy' element={<PrivacyPolicy />} />
              <Route path='/terms-of-service' element={<TermsOfService />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/delete-account' element={<DeleteAccount />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path='*' element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </TooltipProvider>
    </QueryClientProvider>
  )
}

export default App
